// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"82bb9469","455":"ad7ba221","977":"3ef42985"}[chunkId] + ".chunk.js";
};